import { v4 as uuid } from 'uuid';

/**
 * This middleware has the responsibility of creating and updating the logBasePayload, which is appended to all log messages.
 */
const routeLogger = async ({
    req,
    route,
    $cookies,
    store
}) => {
    const uniqueConversationId = uuid();
    $cookies.set('x-je-conversation', uniqueConversationId);

    const logBasePayload = {
        // Universal values
        tenant: store.state.globalisation.tenant,
        locale: store.state.globalisation.locale,
        uniqueUserId: $cookies.get('je-auser'),
        conversationId: uniqueConversationId,
        ...(process.server ? {
            // Server-side
            fullPath: req.originalUrl,
            instancePosition: process.env.INSTANCE_POSITION,
            isPilot: process.env.IS_PILOT,
            userAgent: req.headers['user-agent'] || undefined
        } : {
            // Client-side
            fullPath: route.fullPath,
            userAgent: navigator.userAgent
        })
    };

    // Store the payload in state, so we can extract it while logging
    await store.dispatch('logging/set', logBasePayload);
};

export default routeLogger;
